export default class newsPage {
    constructor(_effect){

        this.dheader = $(".headerglobalnavi");
        this.dheaderCookie = $(".cookiePolicy");
        this.dfooterTop = $(".moreOnDenso.baseComponentStructure");
        this.dfooter = $(".footer.baseComponentStructure");
        this.$logo = $("#p-news-logo");
        this.$menu = $("#c-pager");

        this.ease = CustomEase.create("custom", "M0,0,C0.126,0.382,0.282,0.674,0.44,0.822,0.632,1.002,0.818,1.001,1,1");

        this.effect = _effect;

        this.resize();

        this.dfooter.insertAfter('#l-body');
        this.dfooterTop.insertAfter('#l-body');

    }

    init(_status){

        this.$root = $("#l-root");
        this.$titleLine = $("#p-news__pagetitle .line");
        this.$titleText = $("#p-news__pagetitle .en");
        this.$mainImage = $("#p-news__image");

        _status.scrollStart = false;
        _status.scrollEnd = true;

        TweenLite.set(this.dheader , { css: {'position':'fixed'}});

        if(Useragnt.mobile){
            TweenLite.set(this.$logo , { x: -200 });
            TweenLite.set(this.$menu , { x: 100 });
        }else{
            TweenLite.set(this.$menu , { x: -100 });
        }

        TweenLite.set($('#news.doc') , { css:{'z-index':1}});

        TweenLite.set(this.$logo , { opacity:1});

        this.splash();

        $('.cookiePolicy__close a').on('click', () => {
            this.resize();
        });

    }

    splash(){

        TweenMax.to(this.$root,.68, {
            opacity: 1,
            display: 'block',
            ease: Power2.easeOut
        });

        this.effect.newsText(this.$titleText,"show");
        setTimeout(() => {
            this.effect.newsLine(this.$titleLine,"show");
            setTimeout(() => {
                this.effect.newsImage(this.$mainImage,"show");
            },'5e2');
            TweenMax.to([this.dheader,this.dheaderCookie], .88 , {
                delay: .7,
                y: 0,
                ease: this.ease
            });
            TweenMax.to([this.$logo,this.$menu], .88 , {
                delay: .7,
                x: 0,
                ease: this.ease
            });
        },'7e2');

    }

    motion(_status,_this){

    }

    resize() {

        setTimeout(() => {
            if (Useragnt.mobile) {
                TweenLite.to($("#p-news__pagetitle"), .48, {css: {'padding-top': this.dheader.height() + 45}});
                TweenMax.to([this.$logo, this.$menu], .48, {
                    y: this.dheader.height(),
                    ease: this.ease,
                });
            } else {
                TweenLite.to($("#p-news__pagetitle"), .48, {css: {'margin-top': this.dheader.height()}});
            }
        },'5e2');

    }
}
